import React from "react";
import { Spinner } from "reactstrap";

const ChatBubble = ({
  messages,
  couier,
  vendor,
  isLoading,
  messagesEndRef,
}) => {
  const user = JSON.parse(localStorage.getItem("user"));
  const sender_id = user.id;
  const sender_name = user.name;
  return (
    <div className={`chat-body ${isLoading ? "skeleton" : ""}`}>
      {messages?.map((msg, i) => {
        return (
          <div className="px-2 d-flex w-100 mb-2" key={i}>
            <div
              className={`chat-bubble ${
                msg.sender_type === "admin" ? "sender" : "receiver"
              }`}
            >
              <h6 className="me-auto mb-2">
                {msg.sender_type === "admin"
                  ? sender_name
                  : msg.sender_type === "vendor"
                    ? vendor?.full_name
                    : msg.sender_type === "courier"
                      ? couier?.name
                      : ""}
              </h6>

              <div className="mb-2">{msg.content}</div>

              <div className="me-auto date">
                {
                  msg?.created_at&& msg?.created_at
                    .replace("T", " ")
                    .replace("Z", "")
                    .split(".")[0]
                }
              </div>
            </div>{" "}
            <div className="ms-2">
              {msg.status === "loading" ? (
                <Spinner size="sm" color="primary" />
              ) : msg.status === "success" ? (
                <span style={{ color: "green" }}>✔</span>
              ) : msg.status === "error" ? (
                <span style={{ color: "red" }}>❌</span>
              ) : (
                ""
              )}
            </div>
            <div ref={messagesEndRef} />
          </div>
        );
      })}
    </div>
  );
};

export default ChatBubble;
